import { createPortal } from 'react-dom'
import MenuFlyoutRow from '../MenuFlyoutRow/MenuFlyoutRow'
import type { MenuFamilyView, MenuFlyoutControls, MenuIconProps } from '../types'
import { StyledFlyoutArrow, StyledFlyoutCard, StyledFlyoutTitle } from '../styled-components'

interface MenuFlyoutProps {
  hidden: boolean
  family: MenuFamilyView
  flyout: MenuFlyoutControls
  iconProps: MenuIconProps
}

const MenuFlyout = ({ hidden, family, flyout, iconProps }: MenuFlyoutProps) => {
  if (hidden || !flyout.placement) return null

  return createPortal(
    <StyledFlyoutCard
      ref={flyout.ref}
      id={flyout.id}
      style={flyout.placement.card}
      onMouseEnter={flyout.onMouseEnter}
      onMouseLeave={flyout.onMouseLeave}
      onKeyDown={flyout.onKeyDown}
    >
      <StyledFlyoutArrow style={flyout.placement.arrow} />
      <StyledFlyoutTitle id={flyout.titleId}>{family.label}</StyledFlyoutTitle>
      <div role='menu' aria-labelledby={flyout.titleId}>
        {family.items.map(item => (
          <MenuFlyoutRow key={item.id} item={item} iconProps={iconProps} onClick={flyout.onRowClick} />
        ))}
      </div>
    </StyledFlyoutCard>,
    document.body,
  )
}

export default MenuFlyout
